import React from 'react';
import { MyTail } from '@containers';

const App: React.FC = () => (
  <MyTail />
);

export default App;
